<ng-container *ngIf="!!params">
    <tt-tabs ttRememberId="w_workdetails.bg_workdetails_group" [(ttSelectedId)]="params.bg_workdetails_group">
        <tt-tab ttId="REGISTER" ttLabel="work_details_group_register"></tt-tab>
        <tt-tab ttId="PLAN" ttLabel="work_details_group_plan"></tt-tab>
        <tt-tab *ngIf="params.show_next_activity === '1'" ttId="PLANS" ttLabel="work_details_group_plans"></tt-tab>
    </tt-tabs>

    <tt-card>
        <tt-input ttLabel="cust_name" [(ttModel)]="params.cust_name" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="customersmenu" [ttGotoParms]="{ cust_no: params.cust_no }"></tt-form-field-button>
        </tt-input>
        <tt-input *ngIf="params.project_keyno !== '0'" ttLabel="project_name" [(ttModel)]="params.project_name" ttReadonly>
            <tt-form-field-button
                buttons
                *ngIf="params.show_goto_project === '1'"
                ttIcon="fas fa-chevron-right"
                ttGoto="projectmenu"
                [ttGotoParms]="{ project_keyno: params.project_keyno }"
            ></tt-form-field-button>
        </tt-input>
        <tt-textarea ttLabel="job_description" [(ttModel)]="params.note" ttReadonly></tt-textarea>
        <tt-input *ngIf="+params.serviceobject_keyno > 0" ttLabel="serviceobject_name" [(ttModel)]="params.serviceobject_name" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="serviceobjectmenu" [ttGotoParms]="{ serviceobject_keyno: params.serviceobject_keyno }"></tt-form-field-button>
        </tt-input>
        <tt-select
            ttLabel="actstatus"
            [(ttModel)]="params.actstatus_keyno"
            (ttModelChange)="onActivityStatusChanged()"
            [ttData]="activityStatuses"
            ttDataId="actstatus_keyno"
            ttDataName="actstatus_name"
        ></tt-select>
        <tt-input *ngIf="params.video_url > ''" ttLabel="video_url" [(ttModel)]="params.video_url" ttReadonly>
            <tt-form-field-button buttons ttIcon="far fa-video" (ttClick)="openVideoUrl()"></tt-form-field-button>
        </tt-input>
        <tt-textarea *ngIf="params.solution_note > ''" ttLabel="solution_note" [(ttModel)]="params.solution_note" ttReadonly></tt-textarea>
        <tt-input *ngIf="+params.order_internal_no > 0" ttLabel="order_name" [(ttModel)]="params.order_name" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="orderhead" [ttGotoParms]="{ order_internal_no: params.order_internal_no }"></tt-form-field-button>
        </tt-input>
        <tt-input *ngIf="+params.purch_internal_no > 0" ttLabel="purch_order_no" [(ttModel)]="params.purch_order_no" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="purchhead" [ttGotoParms]="{ purch_internal_no: params.purch_internal_no }"></tt-form-field-button>
        </tt-input>
        <tt-input-phone [(ttModel)]="params.cust_telephone" ttReadonly></tt-input-phone>
        <tt-work-details-register-functions [hidden]="params.bg_workdetails_group !== 'REGISTER'" [params]="params" (deleted)="navigator?.back()"></tt-work-details-register-functions>
        <tt-work-details-plan-functions [hidden]="params.bg_workdetails_group !== 'PLAN'" [params]="params"></tt-work-details-plan-functions>
        <ng-container *ngIf="params.show_next_activity === '1'">
            <tt-list [hidden]="params.bg_workdetails_group !== 'PLANS'" [ttData]="subtasks" ttBadge="nbr_of_subtasks"></tt-list>
            <tt-work-details-plans-functions [hidden]="params.bg_workdetails_group !== 'PLANS'" [params]="params"></tt-work-details-plans-functions>
        </ng-container>
        <tt-button-settings *ngIf="params.show_setting === '1'" ttWebpageName="workdetails"></tt-button-settings>
    </tt-card>
</ng-container>
